// SMB Afrique Éditions — Static HTML mode
// The site uses static HTML pages served from /app/frontend/public/.
// React is intentionally unmounted to preserve the validated design.
const root = document.getElementById("root");
if (root) {
  // Only mount React on dedicated React routes (none currently used in this project).
  // eslint-disable-next-line no-console
  console.log("React root detected on static page — skipping mount.");
}
